import {Language} from "./language.model";
import {Contract} from "./contract.model";
import {ProjectSettings} from "./project-settings/project-settings.model";

export class Project {
  title: string | null = null;
  name?: string | null = null;
  projectShortName?: string | null = null;
  websiteURL?: string | null = null;
  queryString?: string | null = null;
  visible?: boolean = false;
  active?: boolean = false;
  allowedLanguages?: Language[] | null = null;
  settings?: ProjectSettings | null = null;
  allowPostal?: boolean = false;
  contract?: Contract | null = null;
  openForRegistration?: boolean = false;
}
